var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('transition',{attrs:{"name":"view","appear":""}},[_c('div',{attrs:{"id":"app"}},[(!_vm.navigation)?_c('Navigation'):_vm._e(),_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }